import {FC} from 'react';

interface RibbonProps {}

export const Ribbon: FC<RibbonProps> = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.81431 13.5714C13.3647 13.5714 16.2429 10.6932 16.2429 7.1428C16.2429 3.5924 13.3647 0.714233 9.81431 0.714233C6.26391 0.714233 3.38574 3.5924 3.38574 7.1428C3.38574 10.6932 6.26391 13.5714 9.81431 13.5714Z"
        stroke="black"
        strokeWidth="1.42857"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.81417 9.99993C11.3921 9.99993 12.6713 8.72074 12.6713 7.14279C12.6713 5.56483 11.3921 4.28564 9.81417 4.28564C8.23622 4.28564 6.95703 5.56483 6.95703 7.14279C6.95703 8.72074 8.23622 9.99993 9.81417 9.99993Z"
        stroke="black"
        strokeWidth="1.42857"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.57184 13.457L7.31469 18.7428C7.28982 18.8432 7.24382 18.9372 7.17978 19.0185C7.11573 19.0998 7.03511 19.1665 6.94327 19.2142C6.84633 19.2563 6.74179 19.278 6.63612 19.278C6.53045 19.278 6.42591 19.2563 6.32898 19.2142L1.58612 17.1428C1.48664 17.0957 1.3991 17.0268 1.33008 16.9411C1.26106 16.8554 1.21235 16.7551 1.1876 16.6479C1.16286 16.5407 1.16273 16.4292 1.18721 16.322C1.2117 16.2147 1.26017 16.1143 1.32898 16.0285L5.00041 11.4285"
        stroke="black"
        strokeWidth="1.42857"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.4287 13.3857L12.7144 18.7428C12.74 18.845 12.7878 18.9402 12.8545 19.0217C12.9212 19.1032 13.0051 19.169 13.1001 19.2142C13.1944 19.2568 13.2967 19.2789 13.4001 19.2789C13.5036 19.2789 13.6059 19.2568 13.7001 19.2142L18.4144 17.1428C18.5154 17.0963 18.6041 17.027 18.6736 16.9402C18.743 16.8533 18.7913 16.7515 18.8144 16.6428C18.8415 16.5365 18.8427 16.4252 18.8178 16.3183C18.793 16.2114 18.7428 16.112 18.6716 16.0285L14.843 11.1571"
        stroke="black"
        strokeWidth="1.42857"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
